import AppBadge from '../atoms/AppBadge';
import AppButton from '../atoms/AppButton';

function PageHeader({ title, badge, action }) {
  return (
    <div className="d-flex justify-content-between align-items-center gap-2 mb-4 flex-wrap">
      <div className="d-flex align-items-center gap-2 flex-wrap">
        <h4 className="fw-semibold mb-0" style={{ color: 'var(--color-neutral)' }}>{title}</h4>
        {badge && <AppBadge variant="amber">{badge}</AppBadge>}
      </div>
      {action && (
        <AppButton variant="primary" onClick={action.onClick}>
          {action.label}
        </AppButton>
      )}
    </div>
  );
}

export default PageHeader;
